import React from 'react';
import ObjCommonFilterSelection from 'src/component/custom/ObjCommonFilterSelection';
import { SearchBom } from '../Admin/Bom/SearchBom';
import { AdminBomList } from '../Admin/Bom/AdminBomList';
import ShowAlert from 'src/component/Global/ShowAlert';
import AdminConsoleHeader from "../Admin/AdminConsoleHeader";
import Constants from 'src/helper/Constants';
import System from 'src/helper/system';

const BomManagementTab = () => {
    const { translation:t } = System;
    const { adminConsoleTab: { MainTab } } = Constants

    return (
        <>
            <div className='adminconsole-container'>
                <AdminConsoleHeader title={t('bomViewer')} tab={MainTab} header={t('sfdcBomIdManger')} />

                <div className="bs5 row mt-2">
                    <div className='col-12'>
                        <ShowAlert />
                    </div>
                </div>

                <div className='accountdetails mt-2 bom-management'>
                    <div className='acsearchuser'>
                        <SearchBom />
                    </div>
                    <ObjCommonFilterSelection />
                    <div>
                        <AdminBomList />
                    </div>
                </div>

            </div>
        </>
    );
}

export default BomManagementTab;